// AuthProvider.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchToken, storeToken, removeToken } from './auth';
import axios from 'axios';
import { serverUrl } from './ConfigHolder';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // const [token, setToken] = useState(() => {
  //   return fetchToken();
  // });
   const [token, setToken] = useState( fetchToken());


  const login = async (credentials) => {
    // console.log('login:', credentials)
    try {
      const response = await axios.post(`${serverUrl}/login`, credentials, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      // if (!response.data.token) {
      //   throw new Error('Login failed');
      // }
  
      const authToken = response.data.token;
      // console.log(authToken)
      setToken(authToken);
      storeToken (authToken);
      return true;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const register = async (userInfo) => {

    try {
      const response = await axios.post(`${serverUrl}/register`, userInfo, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      // if (!response.data.token) {
      //   throw new Error('Registration failed');
      // }
  
      const authToken = response.data.token;
      setToken(authToken);
      storeToken (authToken);
      return true;
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  };

  const send_confirmation = async (email) => {
    try {
      const response = await axios.post(`${serverUrl}/send_confirmation`, {email: email}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data.message;
    } catch (error) {
      console.error('Sending confirmation error:', error);
      throw error;     
    }
  }

  const logout = () => {
    console.log('Logging out')
    setToken(null);
    storeToken(null);
    removeToken();
    };


  const isAuthenticated = () => {
    // const ret = !!token
    const t = fetchToken();
    const ret = t ? true :false;
    // const ret =  !!fetchToken();

    // console.log('isAuthenticated? ', ret, t)
    return ret;
  };

  useEffect(() => {
    // Optionally, you can check if the token is still valid here
    // console.log('useEffec token ', token)
  }, []);//[token]);

 
  


  return (
    <AuthContext.Provider value={{ token, register, login, logout, isAuthenticated, send_confirmation }}>
      {children}
    </AuthContext.Provider>
  );
};
